webpackJsonp([1],{

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./src/quiz.js
/* eslint quotes: ["error", "double", { "avoidEscape": true }] */

var quiz = [{
  title: "Z jakich 3 warstw składa się JavaScript?",
  answers: ["Core, BOM, DOM", "Webkit, DevTools, HTML", "Core, DOM, HTML", "HTML, CSS, obrazki"],
  correctAnswerIndex: 0
}, {
  title: "Różnica między `==` & `===`?",
  answers: ["żadna", "jest, ale nie pamiętam", "`==` spr. typ, a potem wartość, `===` spr. od razu wartość, nie spr. typu", "`===` spr. typ, a potem wartość, `==` spr. od razu wartość, nie spr. typu"],
  correctAnswerIndex: 3
}, {
  title: "Różnica między `null` a `undefined`?",
  answers: ["żadna", "jest, ale nie pamiętam", "`null` jest nieokreślonym obiektem, `undefined` jest wartością nieokreśloną", "`null` jest pustą wartością, `undefined` jest tym samym"],
  correctAnswerIndex: 2
}, {
  title: "W jaki sposób można odwrócić ciąg znaków? Z **pies** otrzymać **seip**.",
  answers: ["`'pies'.reverse()`", "`'pies'.split('').reverse().join('')`", "`'pies'.invert()`", "`'pies'.join('').reverse().split('')`", "`'pies'.flip()`"],
  correctAnswerIndex: 1
}, {
  title: "Co zwróci operator `typeof` wykonany przez takimi wartościami: `[]`, `{}`, `1`, `NaN`, `null`, `pies`, `Function`",
  answers: ["array, object, number, number, null, string, function", "array, object, number, number, object, string, function", "object, object, number, number, null, string, function", "object, object, number, number, object, string, function", "object, object, number, undefined, null, string, function"],
  correctAnswerIndex: 3
}, {
  title: "Jak usunąć element (znacznik) z DOM (Document Object Model)?",
  answers: ["`element.removeNode()`", "`element.removeElement()`", "`element.parentNode.removeChild(element)`", "`element.remove()`"],
  correctAnswerIndex: 2
}, {
  title: "Jak skopiować tablicę?",
  answers: ["`[1, 2].copy(true)`;", "`[1, 2].copy()`;", "`[1, 2].clone()`;", "`[1, 2].slice(0)`;"],
  correctAnswerIndex: 3
}];
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AddQuestion.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AddQuestion = ({
  name: 'add-question',
  data: function data() {
    return {
      newQ: null,
      answer1: null,
      answer2: null,
      correctIndex: null,
      modalVisible: false
    };
  },

  props: { numQuestions: { type: Number } },
  computed: {
    normalizeQuestion: function normalizeQuestion() {
      return {
        title: this.newQ,
        answers: [this.answer1, this.answer2],
        correctAnswerIndex: +this.correctIndex
      };
    }
  },
  methods: {
    addQ: function addQ() {
      this.$emit('new-question', this.normalizeQuestion);
      this.$refs.form.reset();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9fd5014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddQuestion.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{model:{value:(_vm.modalVisible),callback:function ($$v) {_vm.modalVisible=$$v},expression:"modalVisible"}},[_c('v-btn',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("Dodaj pytanie")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"label":"add your question"},model:{value:(_vm.newQ),callback:function ($$v) {_vm.newQ=$$v},expression:"newQ"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"answer1"},model:{value:(_vm.answer1),callback:function ($$v) {_vm.answer1=$$v},expression:"answer1"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"answer2"},model:{value:(_vm.answer2),callback:function ($$v) {_vm.answer2=$$v},expression:"answer2"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"index poprawnej odp","type":"number","min":"0","max":"1"},model:{value:(_vm.correctIndex),callback:function ($$v) {_vm.correctIndex=$$v},expression:"correctIndex"}}),_vm._v(" "),_c('p',[_vm._v("Your Q: "+_vm._s(_vm.newQ)+" ")]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{on:{"click":_vm.addQ}},[_vm._v("\n            dodaj")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_AddQuestion = (esExports);
// CONCATENATED MODULE: ./src/components/AddQuestion.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AddQuestion,
  components_AddQuestion,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_AddQuestion = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
  components: {
    'add-question': src_components_AddQuestion },
  data: function data() {
    return {
      quiz: quiz,
      currentQuestionIndex: 0,
      userAnswer: null,
      userWon: false,
      newQuestion: null
    };
  },

  computed: {
    currentQuestion: function currentQuestion() {
      return quiz[this.currentQuestionIndex];
    },
    isUserCorrect: function isUserCorrect() {
      return this.currentQuestion.correctAnswerIndex === this.userAnswer;
    }
  },
  methods: {
    getAnswer: function getAnswer(answerIndex) {
      if (this.userAnswer === null) {
        this.userAnswer = answerIndex;
      }
    },
    getAnswerStatus: function getAnswerStatus(answerIndex) {
      var index = this.currentQuestion.correctAnswerIndex;
      if (index === answerIndex && answerIndex === this.userAnswer) {
        if (index === this.quiz.length - 1) {
          this.userWon = true;
        }
        return "success";
      } else if (index !== answerIndex && answerIndex === this.userAnswer) {
        return "error";
      } else {
        return "secondary";
      }
    },
    getNextQuestion: function getNextQuestion() {
      if (this.currentQuestionIndex < quiz.length - 1) {
        this.currentQuestionIndex++;
        this.userAnswer = null;
      }
    },
    startAgain: function startAgain() {
      this.currentQuestionIndex = 0;
      this.userAnswer = null;
    },
    addQuestion: function addQuestion(newQuestion) {
      if (newQuestion.title !== this.quiz[quiz.length - 1].title) {
        this.quiz.push(newQuestion);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ed2b032","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[_c('v-content',[_c('v-container',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('img',{attrs:{"src":"https://logos-download.com/wp-content/uploads/2016/09/Who_Wants_To_Be_A_Millionaire_logo_logotype-700x657.png","height":"200px"}}),_vm._v(" "),(_vm.userWon)?_c('div',{staticClass:"success"},[_vm._v("\n            GRATULACJE! Wygrałeś $ 1 000 000\n          ")]):_vm._e(),_vm._v(" "),_c('v-card',[_c('v-card-title',{attrs:{"id":"quiz"}},[_vm._v(" "+_vm._s(_vm.currentQuestion.title))]),_vm._v(" "),_c('v-card-text',[_c('v-list',_vm._l((_vm.currentQuestion.answers),function(answer,answerIndex){return _c('v-list-tile',{key:answerIndex,class:_vm.getAnswerStatus(answerIndex),on:{"click":function($event){_vm.getAnswer(answerIndex)}}},[_vm._v("\n                  "+_vm._s(answer)+"\n                ")])}))],1),_vm._v(" "),_c('v-card-actions',[(_vm.isUserCorrect)?_c('v-btn',{on:{"click":function($event){_vm.getNextQuestion()}}},[_vm._v("\n                dalej")]):_c('v-btn',{on:{"click":function($event){_vm.startAgain()}}},[_vm._v("\n                początek")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('add-question',{on:{"new-question":function($event){_vm.addQuestion($event)}}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.newQuestion))])],1)],1)],1)],1)],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("lATg")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.min.css
var vuetify_min = __webpack_require__("7zck");
var vuetify_min_default = /*#__PURE__*/__webpack_require__.n(vuetify_min);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





vue_esm["a" /* default */].use(vuetify_default.a);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "lATg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.543649ab92028c2e0ffc.js